export const CREDIT_LINE_DATA_PROVIDED = 'CREDIT_LINE_DATA_PROVIDED';
export const INITIAL = 'INITIAL';
export const CREDIT_APPROVED = 'CREDIT_APPROVED';



// WEBPACK FOOTER //
// ./src/constants/cardApplicationStatusTypes.js